<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { push } from 'svelte-spa-router';
  import { IconArrowLeft, IconBrandGithub } from '@tabler/icons-svelte';

  export let embedded = false;
</script>

{#if !embedded}
  <div class="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-slate-50 dark:from-slate-900 dark:via-purple-900 dark:to-slate-900 flex items-center justify-center p-4 transition-colors duration-300">
    <div class="w-full max-w-4xl">
      <!-- Back Button -->
      <button
        on:click={() => push('/')}
        class="glass-button flex items-center gap-2 px-4 py-2 rounded-lg mb-6 text-slate-900 dark:text-white"
        aria-label="Back to home"
      >
        <IconArrowLeft class="w-5 h-5" />
        <span>{$_('pages.back')}</span>
      </button>

      <!-- Datenschutz Card -->
      <div class="glass-card p-8 md:p-12 rounded-3xl shadow-2xl">
        <h1 class="text-3xl md:text-4xl font-bold text-custom-heading dark:text-white text-center mb-8">
          {$_(`pages.datenschutz.title`)}
        </h1>

        <div class="prose prose-slate dark:prose-invert max-w-none text-custom dark:text-white">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section1.title`)}
            </h2>
            <p class="text-custom dark:text-white mb-4">
              {$_(`pages.datenschutz.section1.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section2.title`)}
            </h2>
            <p class="text-custom dark:text-white mb-4">
              {$_(`pages.datenschutz.section2.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section3.title`)}
            </h2>
            <p class="text-custom dark:text-white mb-4">
              {$_(`pages.datenschutz.section3.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section4.title`)}
            </h2>
            <p class="text-custom dark:text-white mb-4">
              {$_(`pages.datenschutz.section4.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section5.title`)}
            </h2>
            <p class="text-custom dark:text-white mb-4">
              {$_(`pages.datenschutz.section5.content`)}
            </p>
            <div class="mt-4">
              <a
                href="https://github.com/kieksme/kieks.me.meetingcostcounter"
                target="_blank"
                rel="noopener noreferrer"
                class="glass-button inline-flex items-center gap-2 px-6 py-3 rounded-lg text-custom dark:text-white hover:bg-white/60 dark:hover:bg-white/20 transition-all"
              >
                <IconBrandGithub class="w-5 h-5" />
                <span>{$_(`pages.datenschutz.github.link`)}</span>
              </a>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.datenschutz.section6.title`)}
            </h2>
            <p class="text-custom dark:text-white">
              {$_(`pages.datenschutz.section6.content`)}
            </p>
          </section>

          <section class="text-sm text-custom-secondary dark:text-white/70">
            <p>{$_(`pages.datenschutz.lastUpdated`)}</p>
          </section>
        </div>
      </div>
    </div>
  </div>
{:else}
  <!-- Datenschutz Content (embedded, ohne Card) -->
  <div class="p-8 md:p-12">
    <h1 class="text-3xl md:text-4xl font-bold text-custom-heading dark:text-white text-center mb-8">
      {$_(`pages.datenschutz.title`)}
    </h1>

    <div class="prose prose-slate dark:prose-invert max-w-none text-custom dark:text-white">
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section1.title`)}
        </h2>
        <p class="text-custom dark:text-white mb-4">
          {$_(`pages.datenschutz.section1.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section2.title`)}
        </h2>
        <p class="text-custom dark:text-white mb-4">
          {$_(`pages.datenschutz.section2.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section3.title`)}
        </h2>
        <p class="text-custom dark:text-white mb-4">
          {$_(`pages.datenschutz.section3.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section4.title`)}
        </h2>
        <p class="text-custom dark:text-white mb-4">
          {$_(`pages.datenschutz.section4.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section5.title`)}
        </h2>
        <p class="text-custom dark:text-white mb-4">
          {$_(`pages.datenschutz.section5.content`)}
        </p>
        <div class="mt-4">
          <a
            href="https://github.com/kieksme/kieks.me.meetingcostcounter"
            target="_blank"
            rel="noopener noreferrer"
            class="glass-button inline-flex items-center gap-2 px-6 py-3 rounded-lg text-custom dark:text-white hover:bg-white/60 dark:hover:bg-white/20 transition-all"
          >
            <IconBrandGithub class="w-5 h-5" />
            <span>{$_(`pages.datenschutz.github.link`)}</span>
          </a>
        </div>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.datenschutz.section6.title`)}
        </h2>
        <p class="text-custom dark:text-white">
          {$_(`pages.datenschutz.section6.content`)}
        </p>
      </section>

      <section class="text-sm text-custom-secondary dark:text-white/70">
        <p>{$_(`pages.datenschutz.lastUpdated`)}</p>
      </section>
    </div>
  </div>
{/if}
